import { getAxiosInstance } from '../../dataService';

const getHeadersHMS = apiToken => ({
	headers: {
		Authorization: `Bearer ${apiToken}`,
	},
});

const getHeaders = ssId => ({
	headers: ssId
		? {
				'X-SS-ID': ssId,
		  }
		: {},
});

export const fetchPreviouslyAssignedHMSAdminSite = async ({ queryKey }) => {
	const [, apiEnv, apiToken, program, memberId] = queryKey;

	return (
		await getAxiosInstance(apiEnv).get(
			`/provider/memberProgramDetailHistory/${program}`,
			{
				params: {
					memberId,
				},
				...getHeadersHMS(apiToken),
			}
		)
	).data;
};

export const fetchPreviouslyAssignedAshCareAdminSite = async ({ queryKey }) => {
	const [, apiEnv, ssId, program, memberId] = queryKey;

	return (
		await getAxiosInstance(apiEnv).get(
			`/provider/memberProgramDetailHistory/${program}`,
			{
				params: {
					memberId,
				},
				...getHeaders(ssId),
			}
		)
	).data;
};
